import { useEffect, useState } from "react";
import ResponsiveAppBar from "../../../../layouts/navbar";
import { Footer } from "../../../../layouts/footer";
import { useAppDispatch, useAppSelector } from "../../../../../app/redux/hooks";

export const AboutUs = () => {
  const aboutUs = useAppSelector((state) => state.FooterDataState);
  const dispatch = useAppDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <ResponsiveAppBar />
      <div
        id="wrapper"
        style={{
          fontFamily: "Albert Sans, sans-serif",
          fontSize: "14px",
          lineHeight: "22px",
          fontWeight: "400",
        }}
      >
        <div className="tf-page-title style-3">
          <div className="container-full">
            <div className="heading text-center">About Us</div>
          </div>
        </div>
        <section className="flat-spacing-9">
          <div className="container">
            <div className="flat-title my-0">
              <span className="title">We are Navya Bakers</span>
              <p className="sub-title text_black-2">
                Known to all as Navya Bake Shop, the journey of our chain of
                shops began way back in 1984. It all started under the name of
                Navya Bakery and Coffee shop in an assuming part of Kerala
                called Karukutty. Mr. C.V. Ouseph and his sons C.O.Anto, Pauly
                Joseph and Biju Joseph took a leap of faith and plunged into the
                business. 6 employees, a menu card of thirty products and a
                rented space has grown into ten stores, over four hundred and
                fifty mouth watering products and a strong team of around three
                hundred and fifty employees today.
              </p>
            </div>
          </div>
        </section>
        <div className="container">
          <div className="line"></div>
        </div>
        <section className="flat-spacing-23 flat-image-text-section">
          <div className="container">
            <div className="tf-grid-layout md-col-2 tf-img-with-text style-4">
              <div className="tf-image-wrap">
                <img
                  className="w-100 ls-is-cached lazyloaded"
                  data-src="images/cake01.webp"
                  src="images/cake01.webp"
                  alt="collection-img"
                />
              </div>
              <div className="tf-content-wrap px-0 d-flex justify-content-center w-100">
                <div>
                  <div className="heading">Established - 1984</div>
                  <div className="text">
                    Over 35 years, Navya Bake Shop has grown leaps and bounds
                    and we owe it all to the loyalty shown by our customers
                    since its inception. In 1996, Navya Bakery and Coffee shop’s
                    production unit was acquired by Pauly and Biju and was
                    renamed P&amp;B Bakers. In December 2010, Navya was
                    registered and rechristened as Navya Bakes and Confectionery
                    India Private Limited. Our palaharams have become the most
                    soul satisfying and sought after ones for more than three
                    decades and we continue to deliver excellence in a lip
                    smacking and delightful way!
                    <br />
                    <br />
                    With the aim to blend in traditional baking ideas with
                    innovative and creative ones, Navya bakers brings to you
                    heavenly goodies from a vivid range of baked savouries like
                    biscuits, cakes, pastries, rolls, puffs, buns, breads,
                    pizzas and the list goes on. We also take pride in the fact
                    that we are the first bakery in Kerala to use only 100%
                    natural colours and flavours. We go a mile ahead and deliver
                    more than what we promise using our up to date technology,
                    machinery and numerous other resources.
                    <br />
                    <br />
                    We believe in the value of homemade, handcrafted quality
                    baked goods. Not only do they warm the home, but our
                    products will definitely warm your heart. Our favorite time
                    of day is when our first batch comes out of the oven early
                    in the morning, and the fresh smell fills the entire street.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};
